"use client";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from "../../components/ui/table";

const apiUrl = process.env.REACT_APP_API_URL;

const getDietaryId = (dietary: any): string =>
  String(dietary?.dietary_id ?? dietary?.id ?? "");

const getDietaryName = (dietary: any): string =>
  String(dietary?.name ?? dietary?.dietary_name ?? "-");

export default function DietariesTable() {
  const [dietaries, setDietaries] = useState<any[]>([]);
  const navigate = useNavigate();

  const fetchDietaries = async () => {
    const token = localStorage.getItem("token");
    const response = await fetch(`${apiUrl}/dietaries`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        token: token || "",
      },
    });

    const result = await response.json();
    if (!response.ok || result?.success === false) {
      throw new Error(result?.message || `HTTP error! status: ${response.status}`);
    }

    if (Array.isArray(result?.dietaries)) {
      setDietaries(result.dietaries);
      return;
    }
    if (Array.isArray(result?.data)) {
      setDietaries(result.data);
      return;
    }
    setDietaries([]);
  };

  useEffect(() => {
    fetchDietaries().catch(() => setDietaries([]));
  }, []);

  const handleRowClick = (dietary: any) => {
    navigate("/update-dietary", { state: { dietary } });
  };

  return (
    <Table>
      <TableHeader className="bg-[#d9ffa3]">
        <TableRow>
          <TableCell
            isHeader
            className="border border-gray-100 px-4 py-3 dark:border-white/[0.05]"
          >
            <div className="flex cursor-pointer items-center justify-between">
              <div className="flex gap-3">
                <span className="text-theme-xs font-semibold text-gray-700 dark:text-gray-400">
                  Dietary Name
                </span>
              </div>
            </div>
          </TableCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {dietaries.map((dietary, index) => {
          const id = getDietaryId(dietary) || `dietary-${index}`;
          return (
            <TableRow
              key={id}
              className="cursor-pointer hover:bg-[#ffffa3]"
              onClick={() => handleRowClick(dietary)}
            >
              <TableCell className="whitespace-normal border border-gray-100 px-4 py-4 text-xs font-normal text-gray-800 dark:border-white/[0.05] dark:text-white/90">
                {getDietaryName(dietary)}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
